<template>
  <div v-if="item">
    <h5><b> Номер телефона:</b> {{ item.phone }}</h5>
    <h5><b> Имя:</b> {{ item.first_name }}</h5>
    <h5><b> Фамилия:</b> {{ item.last_name }}</h5>
    <h5><b> Email:</b> {{ item.email }}</h5>
    <hr />
    <h5><b> В корзине:</b> {{ item.cart_count }}</h5>
    <h5><b> В избранном:</b> {{ item.wish_count }}</h5>
    <hr />
    <h5><b> Всего заказов:</b> {{ item.checks_count }}</h5>
    <h5><b> Выполнено заказов:</b> {{ item.paid }}</h5>

    <hr />
    <div>
      <h5><b> Корзина:</b></h5>
      <ul v-if="item.cart.length" class="option-list">
        <li v-for="(i, k) in item.cart" :key="k">
          <img :src="i.image" />
          <span>{{ i.sku }} - {{ i.name }} - {{ i.pivot.count }} шт.</span>
        </li>
      </ul>
      <span v-else>Нет товаров</span>
    </div>
    <hr />
    <div>
      <h5><b> Избранное:</b></h5>
      <ul v-if="item.wish.length" class="option-list">
        <li v-for="(i, k) in item.wish" :key="k">
          <img :src="i.image" />
          <span>{{ i.sku }} - {{ i.name }} </span>
        </li>
      </ul>
      <span v-else>Нет товаров</span>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";

import FieldsList from "../FieldsList";

export default {
  watch: {},
  data: () => ({
    cardLink: "clients/card",
    item: null,
    fields: [],
  }),
  components: {
    FieldsList,
  },
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardContent: cardContent,
  },
};
</script>
<style lang="scss">
.option-list {
  & > li {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    & img {
      max-width: 60px;
    }
  }
}
</style>
